import { StatusCwp } from 'Api/insurance/types/insurance.types.cwp';
import { InsuranceStatus } from 'Constants/insuranceStatus.constants';
import { isReregisterableVehicleInsurance } from '../insuranceTypes/insuranceTypes.utils';

export function isUnderChange(insuranceStatus: InsuranceStatus): boolean {
  return InsuranceStatus.UNDER_CHANGE === insuranceStatus;
}

export function isUnderChangeCwp(status: StatusCwp): boolean {
  return (
    StatusCwp.UNDER_CHANGE === status || StatusCwp.UNDER_RENEWAL === status
  );
}

export const isUnderCancellation = (
  insuranceStatus: InsuranceStatus,
): boolean => InsuranceStatus.UNDER_CANCELLATION === insuranceStatus;

export function isDeregisteredAndCanReregister(
  isDeregistered: boolean | undefined,
  insuranceType: string,
  insuranceStatus: InsuranceStatus,
): boolean | undefined {
  return (
    isDeregistered &&
    isReregisterableVehicleInsurance(insuranceType) &&
    !isUnderChange(insuranceStatus)
  );
}
